/* Markus Upgraded (draft), Option B: PRODUCT template JS (blueprint Part 4).
   Vanilla, no dependencies, ES2018, deferred. Loaded by templates/product.liquid AFTER
   assets/upgrade.js, which already owns: window.UpVariantPicker (the swatch mechanic, emits
   "up:variant" on the picker root), the product form add-to-cart, quantity steppers, the
   sticky add-to-cart bar, window.CloneCart, window.UpModal, window.UpToast, window.UpDrawers.
   This file adds the product-only pieces:
     1. Gallery: mobile scroll snap track + dots, desktop single slide + thumb rail, variant
        image jump (listens to "up:variant"), lightbox with prev/next, inline video pause.
     2. Purchase mode (One-time vs Autoship): card selection, schedule row, hidden
        properties[_autoship_intent] toggling (preview mode), selling_plan select (loop mode
        stub), live autoship price per variant.
     3. Details accordion: closed under 900 at load, "Read more" opens Description and scrolls,
        stars link opens the Reviews row.
     4. Related products: fetches Shopify recommendations through the Section Rendering API
        and swaps the skeleton; removes the block when nothing comes back.
     5. Quick pick sheet: "Choose options" on cards fetches {product.url}?section_id=up-quick-pick
        into a bottom sheet (modal at 900+); upgrade.js inits the picker via "up:section:loaded"
        and handles the add; the sheet closes on cart:added.
     6. Sticky columns guard: at 900+ the media column and the buy box are sticky (setting
        pdp_sticky, see assets/up-product.css); a column taller than the viewport gets .is-tall
        so it scrolls normally instead of pinning with an unreachable bottom. */
(function () {
  'use strict';

  var mq900 = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: true };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function icon(name, size) { size = size || 20; return '<svg class="up-icon" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#up-i-' + name + '"></use></svg>'; }
  function parseJson(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function focusables(root) { return qsa(FOCUSABLE, root).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; }); }
  function trapTab(e, root) {
    var f = focusables(root);
    if (!f.length) { e.preventDefault(); root.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* =========================================================== 1. Gallery */
  function initGallery(root) {
    qsa('[data-up-gallery]', root).forEach(function (gal) {
      if (gal.__upGallery) return;
      gal.__upGallery = true;
      var track = qs('[data-up-track]', gal);
      if (!track) return;
      var slides = qsa('[data-up-slide]', track);
      var dots = qsa('[data-up-dot]', gal);
      var thumbs = qsa('[data-up-thumb]', gal);
      var countEl = qs('[data-up-gallery-count]', gal);
      var index = parseInt(gal.getAttribute('data-up-active-index'), 10) || 0;
      var scope = gal.closest('[data-up-product]') || document;
      if (!slides.length) return;

      function pauseOthers(active) {
        slides.forEach(function (s, k) { if (k === active) return; qsa('video', s).forEach(function (v) { try { v.pause(); } catch (e) { /* ignore */ } }); });
      }
      function setActive(i, opts) {
        opts = opts || {};
        if (isNaN(i) || i < 0 || i >= slides.length) return;
        index = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        thumbs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
          if (on && !opts.noScrollThumb && mq900.matches && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { /* ignore */ } }
        });
        if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
        if (!mq900.matches && !opts.fromScroll) {
          var s = slides[i];
          var left = s.offsetLeft - track.offsetLeft;
          try { track.scrollTo({ left: left, behavior: (reduceMotion || opts.instant) ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = left; }
        }
        pauseOthers(i);
      }
      gal.__setActive = setActive;

      /* mobile: swipe -> dots */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (mq900.matches) return;
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              var i = parseInt(en.target.getAttribute('data-index'), 10);
              if (i !== index) setActive(i, { fromScroll: true });
            }
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { setActive(parseInt(d.getAttribute('data-index'), 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); setActive(parseInt(t.getAttribute('data-index'), 10), { noScrollThumb: true }); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); setActive(Math.min(index + 1, slides.length - 1)); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); setActive(Math.max(index - 1, 0)); }
      });

      /* variant image: jump to the slide whose media id matches variant.featured_media */
      scope.addEventListener('up:variant', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v || !v.featured_media || !v.featured_media.id) return;
        var target = -1;
        slides.forEach(function (s, k) { if (String(s.getAttribute('data-media-id')) === String(v.featured_media.id)) target = k; });
        if (target > -1 && target !== index) setActive(target);
      });

      if (mq900.addEventListener) mq900.addEventListener('change', function () { setActive(index, { instant: true }); });

      /* lightbox (borderless modal instance of U-C10) */
      var imgSlides = slides.filter(function (s) { return s.getAttribute('data-media-type') === 'image'; });
      function lightboxHtml(p) {
        var s = imgSlides[p];
        var img = qs('img', s);
        var src = img ? (img.getAttribute('data-up-zoom-src') || img.currentSrc || img.src) : '';
        var nav = '';
        if (imgSlides.length > 1) {
          nav = '<button type="button" class="up-lightbox-nav up-lightbox-nav--prev" data-up-lb-prev aria-label="Previous image"' + (p === 0 ? ' disabled' : '') + '>' + icon('chevron-left', 22) + '</button>' +
            '<button type="button" class="up-lightbox-nav up-lightbox-nav--next" data-up-lb-next aria-label="Next image"' + (p === imgSlides.length - 1 ? ' disabled' : '') + '>' + icon('chevron-right', 22) + '</button>' +
            '<span class="up-lightbox-count" aria-live="polite">' + (p + 1) + ' / ' + imgSlides.length + '</span>';
        }
        return '<div class="up-lightbox" data-up-lightbox><img src="' + esc(src) + '" alt="' + esc(img ? img.alt : '') + '">' + nav + '</div>';
      }
      function openLightbox(slideIndex) {
        if (!window.UpModal || !imgSlides.length) return;
        var pos = imgSlides.indexOf(slides[slideIndex]);
        if (pos < 0) pos = 0;
        window.UpModal.open({ borderless: true, html: lightboxHtml(pos) });
        var body = qs('[data-up-modal-body]');
        function go(p) {
          if (p < 0 || p >= imgSlides.length) return;
          pos = p;
          if (body) body.innerHTML = lightboxHtml(p);
          setActive(slides.indexOf(imgSlides[p]));
          var btn = body ? qs(p >= imgSlides.length - 1 ? '[data-up-lb-prev]' : '[data-up-lb-next]', body) : null;
          if (btn) btn.focus();
        }
        function onClick(e) {
          if (e.target.closest('[data-up-lb-prev]')) go(pos - 1);
          else if (e.target.closest('[data-up-lb-next]')) go(pos + 1);
        }
        function onKey(e) {
          if (e.key === 'ArrowLeft') go(pos - 1);
          else if (e.key === 'ArrowRight') go(pos + 1);
        }
        function cleanup() {
          if (body) body.removeEventListener('click', onClick);
          document.removeEventListener('keydown', onKey);
          document.removeEventListener('up:modal:close', cleanup);
        }
        if (body) body.addEventListener('click', onClick);
        document.addEventListener('keydown', onKey);
        document.addEventListener('up:modal:close', cleanup);
      }
      track.addEventListener('click', function (e) {
        var slide = e.target.closest('[data-up-slide]');
        if (!slide) return;
        var isZoomBtn = !!e.target.closest('[data-up-zoom]');
        var isImg = e.target.tagName === 'IMG' && slide.getAttribute('data-media-type') === 'image';
        if (isZoomBtn || isImg) { e.preventDefault(); openLightbox(parseInt(slide.getAttribute('data-index'), 10)); }
      });

      /* initial sync (no scrolling), then land on the deep linked variant image on mobile */
      setActive(index, { instant: true, fromScroll: true, noScrollThumb: true });
      if (!mq900.matches && index > 0) { requestAnimationFrame(function () { setActive(index, { instant: true }); }); }
    });
  }

  /* ==================================================== 2. Purchase mode */
  function initModes(root) {
    qsa('[data-up-modes]', root).forEach(function (wrap) {
      if (wrap.__upModes) return;
      wrap.__upModes = true;
      var scope = wrap.closest('[data-up-product]') || document;
      var inputs = qsa('[data-up-mode-input]', wrap);
      var labels = qsa('[data-up-mode]', wrap);
      var extra = qs('[data-up-mode-extra]', wrap);
      var schedule = qs('[data-up-schedule]', wrap);
      var intent = qs('[data-up-autoship-intent]', wrap);
      var ack = qs('[data-up-autoship-ack]', wrap);
      var ackHelp = qs('[data-up-ack-help]', wrap);
      var termsProp = qs('[data-up-autoship-terms]', wrap);
      var priceEl = qs('[data-up-autoship-price]', wrap);
      var prices = parseJson(qs('[data-up-autoship-prices]', wrap)) || {};
      var planPrices = parseJson(qs('[data-up-plan-prices]', wrap));
      /* 2026-09-26: per variant savings + plan filtering. A product whose variants carry their own
         plan groups (Nature's Wild Berry: bag and travel jar) lists every group's plans in one
         select; the jar must show only its plans, its price and its own savings tag. */
      var planMeta = parseJson(qs('[data-up-plan-meta]', wrap));
      /* 2026-09-29: set autoship = the set's components, each on its own selling plan
         (custom.kit_autoship). On submit with Autoship picked, the components go to the
         cart via /cart/add.js and the bundle line itself is never posted. */
      var kitData = parseJson(qs('[data-up-kit-autoship]', wrap));
      var autoLabel = qs('[data-up-mode="autoship"]', wrap);
      var titleText = autoLabel ? qs('.up-mode-title-text', autoLabel) : null;
      var tagEl = autoLabel ? qs('.up-mode-tag:not(.up-mode-tag--muted)', autoLabel) : null;
      var isPlans = wrap.getAttribute('data-up-mode-kind') === 'plans';
      var idInput = qs('input[name="id"]', scope);
      var variantId = idInput ? String(idInput.value) : '';

      function currentMode() {
        var c = inputs.filter(function (i) { return i.checked; })[0];
        return c ? c.value : 'one-time';
      }
      function updateTag() {
        if (!planMeta || !titleText) return;
        var m = planMeta[variantId];
        if (!m) return;
        var pct = parseInt(m.pct, 10) || 0;
        var off = m.off ? ' off list' : '';
        titleText.textContent = pct >= 1 ? 'Autoship and save ' + pct + '%' + off : 'Autoship';
        if (pct >= 1) {
          if (!tagEl) { tagEl = document.createElement('span'); tagEl.className = 'up-mode-tag'; titleText.parentNode.appendChild(tagEl); }
          tagEl.textContent = 'Save ' + pct + '%' + off;
          tagEl.hidden = false;
        } else if (tagEl) {
          tagEl.hidden = true;
        }
      }
      function filterSchedule() {
        if (!(isPlans && planPrices && schedule)) return;
        var mine = planPrices[variantId] || {};
        var opts = Array.prototype.slice.call(schedule.options);
        var cur = schedule.options[schedule.selectedIndex];
        var curName = cur ? cur.text : '';
        var pick = null, first = null;
        opts.forEach(function (o) {
          var ok = !!mine[o.value];
          o.hidden = !ok;
          o.disabled = !ok;
          if (ok) { if (!first) first = o; if (!pick && o.text === curName) pick = o; }
        });
        if (!mine[schedule.value]) { var to = pick || first; if (to) schedule.value = to.value; }
      }
      function updatePrice() {
        if (!priceEl) return;
        if (kitData && kitData.variants && kitData.variants[variantId]) {
          priceEl.textContent = '$' + kitData.variants[variantId].total;
          return;
        }
        if (isPlans && planPrices && schedule) {
          var perVariant = planPrices[variantId];
          var s = perVariant ? perVariant[schedule.value] : null;
          if (s) priceEl.textContent = s;
        } else if (prices[variantId]) {
          priceEl.textContent = prices[variantId];
        }
      }
      /* Autoship commitment (Juliano 2026-08-17, re-worded 2026-10-01): 3-order minimum (3 billing cycles, not 3 months), cancel early = full price.
         The shopper must tick the acknowledgment before Autoship can be added; the accepted
         terms ride along as a hidden line item property (_autoship_terms). */
      function submitButtons() {
        return qsa('[data-up-atc], [data-up-sticky-submit]', scope);
      }
      function gateSubmit() {
        var auto = currentMode() === 'autoship';
        var blocked = auto && ack && !ack.checked;
        submitButtons().forEach(function (b) {
          if (blocked) {
            b.disabled = true;
            b.setAttribute('aria-disabled', 'true');
            b.classList.add('is-gated');
          } else if (b.classList.contains('is-gated')) {
            /* only re-enable what this gate disabled; sold out buttons stay disabled */
            b.classList.remove('is-gated');
            b.disabled = false;
            b.removeAttribute('aria-disabled');
          }
        });
        if (ackHelp) ackHelp.hidden = !blocked;
        if (termsProp) termsProp.disabled = !(auto && ack && ack.checked);
      }
      function sync() {
        var m = currentMode();
        var auto = m === 'autoship';
        labels.forEach(function (l) { l.classList.toggle('is-selected', l.getAttribute('data-up-mode') === m); });
        if (extra) extra.hidden = !auto;
        if (isPlans) {
          if (schedule) schedule.disabled = !auto;
        } else if (intent) {
          intent.disabled = !auto;
          if (schedule) intent.value = schedule.value;
        }
        wrap.setAttribute('data-up-mode-selected', m);
        updatePrice();
        gateSubmit();
      }
      if (kitData) {
        var kitAdd = function (ev) {
          if (currentMode() !== 'autoship') return;               /* one-time = the bundle, untouched */
          var kv = kitData.variants && kitData.variants[variantId];
          if (!kv) return;
          ev.preventDefault();
          ev.stopImmediatePropagation();                          /* the theme's own add-to-cart must not also fire */
          if (ack && !ack.checked) { gateSubmit(); return; }
          var planName = schedule ? schedule.value : 'Monthly';
          var qtyEl = qs('input[name="quantity"]', scope);
          var mult = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
          var items = kv.components.map(function (c) {
            var it = { id: parseInt(c.id, 10), quantity: c.qty * mult,
                       properties: { _autoship_terms: '3 order minimum accepted', _autoship_set: document.title.split('\u2013')[0].trim() } };
            if (c.plans && c.plans[planName]) { it.selling_plan = parseInt(c.plans[planName], 10); }
            return it;
          });
          var btns = submitButtons();
          btns.forEach(function (b) { b.disabled = true; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) { throw new Error('cart'); } window.location.href = '/cart'; })
            .catch(function () { btns.forEach(function (b) { b.disabled = false; });
              alert('Could not add the set to the cart. Please try again.'); });
        };
        document.addEventListener('click', function (ev) {
          var b = ev.target && ev.target.closest ? ev.target.closest('[data-up-atc], [data-up-sticky-submit]') : null;
          if (!b || !scope.contains(b)) return;
          kitAdd(ev);
        }, true);
        var kitForm = qs('form[action*="/cart/add"]', scope);
        if (kitForm && !kitForm.__upKit) { kitForm.__upKit = true; kitForm.addEventListener('submit', kitAdd, true); }
      }
      inputs.forEach(function (i) { i.addEventListener('change', sync); });
      if (schedule) schedule.addEventListener('change', sync);
      if (ack) ack.addEventListener('change', gateSubmit);
      scope.addEventListener('up:variant', function (e) {
        var v = e.detail && e.detail.variant;
        if (v) { variantId = String(v.id); filterSchedule(); updatePrice(); updateTag(); }
      });
      filterSchedule();
      sync();
      updateTag();
    });
  }

  /* ================================================ 3. Details + read more */
  function initDetails(root) {
    var details = qs('[data-up-details]', root);
    if (details && !details.__upDetails) {
      details.__upDetails = true;
      /* first present row open at 900+, all closed under 900 */
      if (!mq900.matches) qsa('details[open]', details).forEach(function (d) { d.removeAttribute('open'); });
    }
    qsa('[data-up-read-more]', root).forEach(function (btn) {
      if (btn.__upBound) return;
      btn.__upBound = true;
      btn.addEventListener('click', function () {
        var target = document.getElementById('up-details-description') || (details ? qs('details', details) : null);
        var lead = qs('[data-up-lead]', root);
        if (lead) lead.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
        if (!target) return;
        target.open = true;
        var sum = qs('summary', target);
        try { (sum || target).scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); } catch (e) { (sum || target).scrollIntoView(); }
        if (sum) setTimeout(function () { try { sum.focus({ preventScroll: true }); } catch (e) { sum.focus(); } }, reduceMotion ? 0 : 400);
      });
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-up-stars-link]');
      if (!a) return;
      var row = document.getElementById('up-reviews');
      if (row) row.open = true;
    });
    if (window.location.hash === '#up-reviews') { var r = document.getElementById('up-reviews'); if (r) r.open = true; }
  }

  /* ======================================================== 4. Related */
  function initRelated() {
    var sec = qs('[data-up-related-fetch]');
    if (!sec) return;
    var url = sec.getAttribute('data-up-related-fetch');
    var wrap = sec.closest('[data-up-related-wrap]') || sec;
    function drop() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { drop(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-up-related-wrap]');
        var cards = fresh ? fresh.querySelectorAll('[data-up-card]') : [];
        if (!fresh || !cards.length) { drop(); return; }
        wrap.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('up:section:loaded', { detail: { root: wrap } }));
      })
      .catch(drop);
  }

  /* ==================================================== 5. Quick pick */
  var Sheet = (function () {
    var underlay = null, sheet = null, body = null, lastFocus = null, isOpen = false;
    function ensure() {
      if (underlay) return;
      underlay = document.createElement('div');
      underlay.className = 'up-sheet-underlay';
      underlay.hidden = true;
      underlay.setAttribute('data-up-sheet-underlay', '');
      underlay.innerHTML = '<div class="up-sheet" role="dialog" aria-modal="true" aria-label="Choose options" tabindex="-1" data-up-sheet>' +
        '<div class="up-sheet-handle" aria-hidden="true"></div>' +
        '<button type="button" class="up-icon-btn up-sheet-close" data-up-sheet-close aria-label="Close">' + icon('close', 24) + '</button>' +
        '<div class="up-sheet-body" data-up-sheet-body></div></div>';
      document.body.appendChild(underlay);
      sheet = qs('[data-up-sheet]', underlay);
      body = qs('[data-up-sheet-body]', underlay);
      underlay.addEventListener('click', function (e) { if (e.target === underlay || e.target.closest('[data-up-sheet-close]')) close(); });
      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'Tab') trapTab(e, sheet);
      });
      document.addEventListener('cart:added', function () { if (isOpen) close(true); });
    }
    function show(opener) {
      ensure();
      lastFocus = opener || document.activeElement;
      underlay.hidden = false;
      isOpen = true;
      document.body.classList.add('up-locked');
      document.dispatchEvent(new CustomEvent('up:sheet:open'));
      setTimeout(function () { var f = focusables(sheet); (f[0] || sheet).focus(); }, 30);
    }
    function close(silent) {
      if (!isOpen) return;
      underlay.hidden = true;
      isOpen = false;
      body.innerHTML = '';
      var drawerOpen = window.UpDrawers && window.UpDrawers.isOpen && window.UpDrawers.isOpen();
      if (!drawerOpen) document.body.classList.remove('up-locked');
      if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
      document.dispatchEvent(new CustomEvent('up:sheet:close'));
    }
    function load(url, opener) {
      if (!url) return;
      ensure();
      body.innerHTML = '<div class="up-sheet-loading"><span class="up-sheet-spinner" aria-hidden="true"></span><span class="visually-hidden">Loading</span></div>';
      show(opener);
      var u = url.split('#')[0];
      u += (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=up-quick-pick';
      fetch(u, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          if (!isOpen) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var root = doc.querySelector('[data-up-quick-pick-root]');
          if (!root) { window.location.href = url; return; }
          body.innerHTML = '';
          body.appendChild(document.adoptNode(root));
          var mounted = qs('[data-up-quick-pick-root]', body);
          document.dispatchEvent(new CustomEvent('up:section:loaded', { detail: { root: mounted } }));
          initModes(mounted);
          setTimeout(function () { var f = focusables(mounted); (f[0] || sheet).focus(); }, 30);
        })
        .catch(function () { window.location.href = url; });
    }
    return { load: load, close: close, isOpen: function () { return isOpen; } };
  })();
  window.UpQuickPick = Sheet;

  function initQuickPick() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-up-quick-pick]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
      e.preventDefault();
      Sheet.load(a.getAttribute('data-up-quick-pick-url') || a.getAttribute('href'), a);
    });
  }

  /* ============================================= 6. Sticky columns guard */
  function initStickyColumns() {
    var pdp = qs('[data-up-pdp]');
    if (!pdp) return;
    var mode = pdp.getAttribute('data-up-sticky') || 'auto';
    if (mode === 'none') return;
    var cols = [qs('.up-pdp-col-media', pdp), qs('.up-buy', pdp)].filter(Boolean);
    if (!cols.length) return;
    function headerH() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--up-header-h'));
      return isNaN(v) ? 72 : v;
    }
    var raf = 0;
    function measure() {
      raf = 0;
      if (!mq900.matches) { cols.forEach(function (c) { c.classList.remove('is-tall'); }); return; }
      var room = window.innerHeight - headerH() - 24 - 16;
      cols.forEach(function (c) {
        /* measure the natural height, not a clamped one */
        var h = c.scrollHeight || c.getBoundingClientRect().height;
        c.classList.toggle('is-tall', h > room);
      });
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(measure); }
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(schedule);
      cols.forEach(function (c) { ro.observe(c); });
    } else {
      qsa('img', pdp).forEach(function (img) { if (!img.complete) img.addEventListener('load', schedule, { once: true }); });
      pdp.addEventListener('toggle', schedule, true);
    }
    window.addEventListener('resize', schedule);
    if (mq900.addEventListener) mq900.addEventListener('change', schedule);
    document.addEventListener('up:variant', schedule);
    window.addEventListener('load', schedule);
    measure();
  }

  /* ---------------------------------------------------------------- boot */
  ready(function () {
    initGallery(document);
    initModes(document);
    initDetails(document);
    initRelated();
    initQuickPick();
    initStickyColumns();
    document.addEventListener('up:section:loaded', function (e) {
      var r = e.detail && e.detail.root ? e.detail.root : document;
      initModes(r);
    });
  });
})();
